import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  isHigher?: boolean | 0 | null;
}

const Document = ({ isHigher, ...props }: Props): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={isHigher ? '#00c77e' : '#eb002f'}
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d={isHigher ? 'M12 9L16 15H8L12 9Z' : 'M12 15L16 9H8L12 15Z'}
    />
  </svg>
);

export default Document;
